import { object, preprocess } from 'zod';

import { withIsEnabled } from '@occc/validation';
import {
  LimitDisabledSchemaWithIsEnabled,
  LimitSchema,
  progressPerPeriodLimitSchema,
  progressPerTransactionLimitSchema,
  transactionFrequencyLimitSchema,
  TransactionLimitDisabledSchemaWithIsEnabled,
  TransactionLimitSchema,
  validateMembershipLessThanGlobal,
} from '@occc/feat-limits';

const AwardCountEnabledSchema = object({
  membership: LimitSchema,
  global: LimitSchema,
  transaction: TransactionLimitSchema.optional(),
  progressPerPeriod: progressPerPeriodLimitSchema.optional(),
  progressPerTransaction: progressPerTransactionLimitSchema.optional(),
  transactionFrequency: transactionFrequencyLimitSchema,
}).superRefine((data, ctx) => {
  validateMembershipLessThanGlobal({ membership: data.membership, global: data.global, ctx });
});

const AwardCountDisabledSchema = object({
  membership: preprocess(() => ({}), LimitDisabledSchemaWithIsEnabled),
  global: preprocess(() => ({}), LimitDisabledSchemaWithIsEnabled),
  transaction: preprocess(
    (value) => (value == null ? undefined : {}),
    TransactionLimitDisabledSchemaWithIsEnabled.optional(),
  ),
  progressPerPeriod: progressPerPeriodLimitSchema.optional(),
  progressPerTransaction: progressPerTransactionLimitSchema.optional(),
  transactionFrequency: preprocess(() => ({}), transactionFrequencyLimitSchema),
});

export const ChallengeAwardCountSchema = withIsEnabled(
  AwardCountEnabledSchema,
  AwardCountDisabledSchema,
);
